import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { Globals } from "./common/global";
import { EMPLOYEE_ROUTES } from "./shared/sidebar/employee-menu-item";
import { RouteAccessService } from "./services/route-access.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  authUser: any;
  authorizedRoutes: any[] = [];
  isEmpLogin: boolean = false;

  constructor(
    private routes: Router,
    public globals: Globals,
    private routeService: RouteAccessService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.isEmpLogin = localStorage.getItem("is_loginEmployee") == "true";
    this.authUser = JSON.parse(localStorage.getItem("Auth-user") || "{}");

    if (!this.isEmpLogin) {
      if (localStorage.getItem("Auth-user") != null) {
        // console.log("Auth-user exists, allowing access");
        return true;
      } else {
        this.routes.navigate(["/login"]);
        localStorage.removeItem("is_loginEmployee");
        return false;
      }
    } else {
      this.authorizedRoutes = this.getAuthorizedRoutes(
        EMPLOYEE_ROUTES,
        this.authUser.permissions
      );
      this.routeService.setAuthorizedRoutes(this.authorizedRoutes);
      // const isValidSubmenuPath = this.isPathAuthorized(state.url);
      // console.log("Is path authorized:", isValidSubmenuPath);

      // if (isValidSubmenuPath) {
      if (localStorage.getItem("Auth-user") != null) {
        // console.log("Auth-user exists, allowing access");
        return true;
      } else {
        this.routes.navigate(["/login"]);
        localStorage.removeItem("is_loginEmployee");
        return false;
      }
    }
  }

  getAuthorizedRoutes(routes: any[], permissions: string[]) {
    const permissionModules = new Set(
      permissions.map((item: any) => item.module)
    );

    const filteredRoutes = EMPLOYEE_ROUTES.map((route: any) => {
      if (route.hasSubmenu) {
        const filteredSubmenu = route.submenu.filter((submenu: any) =>
          permissionModules.has(submenu.module)
        );
        if (filteredSubmenu.length > 0) {
          return { ...route, submenu: filteredSubmenu };
        }
        return null;
      } else {
        return (route.module && permissionModules.has(route.module)) ||
          route.ForEmployee
          ? route
          : null;
      }
    }).filter((route: any) => route !== null);

    return filteredRoutes;
  }

  // getAuthorizedRoutes(routes: any[], permissions: string[]) {
  //   const permissionModules = new Set(
  //     permissions.map((item: any) => item.module)
  //   );

  //   const filteredEmployeeRoutes = EMPLOYEE_ROUTES.map((route: any) => {
  //     const filteredSubmenu = route.submenu.filter((submenu: any) =>
  //       Array.from(permissionModules).some((module) =>
  //         submenu.path.includes(module)
  //       )
  //     );
  //     return { ...route, submenu: filteredSubmenu };
  //   }).filter((route: any) => route.submenu.length > 0);

  //   return filteredEmployeeRoutes;
  // }

  isPathAuthorized(path: string) {
    const isAuthorized = this.authorizedRoutes.some(
      (route) => route.path === path
    );
    console.log("Is path authorized:", isAuthorized);
    return isAuthorized;
  }
}
